import { render } from "./CustomerSearch.vue?vue&type=template&id=c688969a"
import script from "./CustomerSearch.vue?vue&type=script&lang=js"
export * from "./CustomerSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__